import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { API_URL } from "../../../config";


const AddCapnoGoSerial = ({ deviceToggleModal, deviceModal, serialkey, HandleSerialkey, chackValidationserialkey, confirmserialkey, confirmpasserror, device_type, HandledeviceType, errorMessege, SaveDevice, confirmKey, setSelectedModules }) => {
    const [modules, setModules] = useState([]);


    const [selectedModuleDetails, setSelectedModuleDetails] = useState([]);
useEffect(()=>{
    setSelectedModuleDetails([])
},[deviceModal])
    const handleBundleChange = (bundleValue) => {
        const selectedEnums = planModulesMap[bundleValue] || [];

        const filteredModules = modules.filter((m) =>
            selectedEnums.includes(m.module_enum)
        );

        const selectedIds = filteredModules.map((m) => m.id);

        setSelectedModules(selectedIds);
        setSelectedModuleDetails(filteredModules); // 👈 for UI display
    };
    const fetchModules = async () => {
        const res = await fetch(API_URL + "/get/all/modules");
        const data = await res.json();
        setModules(data.modules || []);
    };
    useEffect(() => {
        fetchModules();
    }, []);
    const planModulesMap = {
        BASIC: [],
        ADVANCED: [
            "ADVANCED_FEATURES_MODULE",
            "MULTI_USER_MODULE",
            "PRACTICUMS_MODULE",
            "HRV_MODULE",
        ],
        PROFESSIONAL: [
            "ADVANCED_FEATURES_MODULE",
            "MULTI_USER_MODULE",
            "PRACTICUMS_MODULE",
            "HRV_MODULE",
            "CELL_PHONE_MODULE",
            "CLOUD_DATABASE_MODULE",
            "MANAGEMENT_MODULE",
            "EMG_MUSCLE_FEEDBACK_MODULE",
        ],
    };
    return (
        <Modal
            isOpen={deviceModal}
            toggle={deviceToggleModal}
            className="connect-box"
            centered={true}
        >
            <ModalHeader toggle={deviceToggleModal}>
                <span className="ml-1 roititle ">Add</span>
            </ModalHeader>
            <ModalBody>
                <div>
                    <ul className="deviceformlist">
                        <li>
                            <div className="input-group mb-3 w-100 device-input">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">
                                        GO-
                                    </span>
                                </div>
                                <input
                                    type="number"
                                    placeholder="Write serial key"
                                    ref={serialkey}
                                    onChange={HandleSerialkey}
                                />
                            </div>
                            <div className="input-group mb-3 w-100 device-input">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">
                                        GO-
                                    </span>
                                </div>

                                <input
                                    type="number"
                                    placeholder="Confirm serial key"
                                    ref={confirmserialkey}
                                    onChange={chackValidationserialkey}
                                />
                            </div>
                            {confirmKey && (
                                <p className="passworderror">{confirmpasserror}</p>
                            )}
                            <div className="select-device-type">
                                <select
                                    ref={device_type}
                                    onChange={(e) => {
                                        HandledeviceType(e);

                                        const plan =
                                            e.target.value === "11"
                                                ? "BASIC"
                                                : e.target.value === "12"
                                                    ? "ADVANCED"
                                                    : e.target.value === "13"
                                                        ? "PROFESSIONAL"
                                                        : null;

                                        handleBundleChange(plan);
                                    }}
                                >
                                    <option value="null">Select bundle</option>
                                    <option value="11">GO Basic</option>
                                    <option value="12">GO Advanced</option>
                                    <option value="13">GO Professional</option>
                                </select>




                            </div>

                            {errorMessege && (
                                <p className="error-message">All required field</p>
                            )}
                        </li>
                        {selectedModuleDetails.length > 0 && (
                            <div
                                style={{
                                    marginTop: "12px",
                                    padding: "10px",
                                    border: "1px solid #e5e5e5",
                                    borderRadius: "6px",
                                    background: "#fafafa",
                                }}
                            >
                                <strong>Included Modules:</strong>

                                <ul style={{ marginTop: "8px", paddingLeft: "18px", fontSize: "14px" }}>
                                    {selectedModuleDetails.map((m) => (
                                        <li key={m.id}>{m.name}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        <li>
                            <div className="addBtn">
                                <button onClick={() => SaveDevice()}>Add</button>
                            </div>
                        </li>
                    </ul>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default AddCapnoGoSerial;
